import type {ScheduleItem} from '@domain/schedule'
import {roundTo15MinIntervalStart} from '@hconnect/common/utils'
import {dataTestId} from '@hconnect/uikit'
import {useUpmPlantTimezone} from '@hconnect/upm'
import {LockOutlined} from '@mui/icons-material'
import {Stack, Typography} from '@mui/material'
import {useCurrentTimeRounded} from '@widgets/stock-card'
import moment from 'moment-timezone'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../../consts'
import {PlannerSwitch} from '../formComponents'

interface ScheduleItemFixedForOptimizerSwitchProps {
  scheduleItem: ScheduleItem
  handleShutdownAvailabilityChange: (isShutdownAvailable: boolean) => void
}
export const ScheduleItemFixedForOptimizerSwitch: React.FC<
  ScheduleItemFixedForOptimizerSwitchProps
> = ({scheduleItem, handleShutdownAvailabilityChange}) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const timezoneId = useUpmPlantTimezone()
  const nowRounded = useCurrentTimeRounded({timezoneId, roundingFn: roundTo15MinIntervalStart})
  const isDisabled = moment.utc(scheduleItem.end).isBefore(nowRounded)

  const onChange = (isChecked: boolean) => handleShutdownAvailabilityChange(isChecked)

  return (
    <PlannerSwitch
      label={
        <Stack direction="row" alignItems="center" spacing={1}>
          <LockOutlined />
          <Typography>{t('planning.markAsFixedForOptimizer')}</Typography>
        </Stack>
      }
      value={scheduleItem.isFixed}
      onChange={onChange}
      disabled={isDisabled}
      {...dataTestId('is_fixed_switch')}
    />
  )
}
